/**
 * Created by - Ashish Dewangan on 08-07-2024
 * Reason - Created home page
 */
import { useContext, useEffect, useState } from "react";

import homeStyle from "./Home.module.css";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import { homepage, homepageData } from "../../Api/services";
import config, { baseURL } from "../../Api/config";
import { FaCheck } from "react-icons/fa";

import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import parse from "html-react-parser";
import { IoStar } from "react-icons/io5";

const Home = (props) => {
  const [banner, setBannerData] = useState(null);
  const [whoWeAreData, setWhoWeAreData] = useState({});
  const [whyAdyantData, setWhyAdyantData] = useState({});
  const [testimonialData, setTestimonialData] = useState({});
  const [ourDirectorData, setOurDirectorData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [sliderRef, instanceRef] = useKeenSlider({
    breakpoints: {
      "(min-width: 0px)": {
        slides: { perView: 1, spacing: 5 },
      },

      "(min-width: 250px)": {
        slides: { perView: 2, spacing: 10 },
      },
      "(min-width: 300px)": {
        slides: { perView: 2, spacing: 40 },
      },

      "(min-width:350px)": {
        slides: { perView: 3, spacing: 10 },
      },

      "(min-width: 450px)": {
        slides: { perView: 4, spacing: 5 },
      },

      "(min-width: 800px)": {
        slides: { perView: 5, spacing: 10 },
      },

      "(min-width: 1000px)": {
        slides: { perView: 6, spacing: 10 },
      },
      "(min-width: 1200px)": {
        slides: { perView: 7, spacing: 5 },
      },
      "(min-width: 1400px)": {
        slides: { perView: 8, spacing: 5 },
      },
    },
    slides: { perView: 2 },

    loop: true,
  });
  const fetchData = async () => {
    try {
      const response = await homepageData();
      setBannerData(response.banner);
      setWhoWeAreData(response.who_we_are);
      setWhyAdyantData(response.why_adyant);
      setOurDirectorData(response.our_directors);
      setTestimonialData(response.testimonials);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchData();
  }, []);

  console.log(whoWeAreData, "checkkkkkk");

  useEffect(() => {
    const interval = setInterval(() => {
      instanceRef.current?.next();
    }, 3000);

    return () => clearInterval(interval);
  }, [instanceRef]);

  const responsive2 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1201 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1200, min: 1101 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet2: {
      breakpoint: { max: 1100, min: 901 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet3: {
      breakpoint: { max: 900, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 601 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile2: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <>
      {isLoading ? (
        <div className={homeStyle.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      ) : (
        <div className={homeStyle.mainContainer}>
          {banner?.length > 0 ? (
            <Carousel
              responsive={responsive2}
              className={`${homeStyle.homePageBannerImageAndVideo}`}
              showDots={banner?.length > 1 ? true : false}
              autoPlay={banner?.length > 1 ? true : false}
              infinite={banner?.length > 1 ? true : false}
              // autoPlaySpeed={1500}
              autoPlaySpeed={10000}
            >
              {banner?.map((item, index) => (
                <div key={index}>
                  {/\.(mp4|mkv|webm|avi|mov|flv|wmv)$/i.test(
                    item.banner_video_file
                  ) ? (
                    <video
                      autoPlay
                      muted
                      loop
                      className={homeStyle.banner_video}
                    >
                      <source
                        src={`${baseURL}${item.banner_video_file}`}
                        type={`video/${item.banner_video_file
                          .split(".")
                          .pop()}`}
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={`${baseURL}${item.banner_video_file}`}
                      alt={`Banner ${index + 1}`}
                      className={homeStyle.banner_image}
                    />
                  )}
                </div>
              ))}
            </Carousel>
          ) : null}

          {/* Adyant Who Are You */}
          {whoWeAreData?.length > 0 ? (
            <div className={homeStyle.title_field}>
              <h3 className={`${homeStyle.title} ${homeStyle.whoAreYouTitle}`}>Adyant Who Are You !!</h3>
              {whoWeAreData.map((item, index) => (
                <div key={index} className={homeStyle.description_field}>
                  {item.description && typeof item.description === "string"
                    ? parse(item.description)
                    : "No description available"}
                </div>
              ))}
            </div>
          ) : null}

          {/* Console log whyAdyantData */}
          {console.log(whyAdyantData, "why adyant")}

          {/* Why Adyant */}
          {whyAdyantData?.length > 0 ? (
            <div className={homeStyle.whyAdyant}>
              <h3 className={`${homeStyle.title} ${homeStyle.whyAdyantTitle}`}>Why Adyant?</h3>
              <div className={homeStyle.itemsContainer}>
                {whyAdyantData.map((item, index) => (
                  <div key={index} className={homeStyle.item}>
                    <img
                      src={config.baseURL + item?.image}
                      alt={item?.title || "Icon"}
                      className={homeStyle.icon}
                    />
                    <h4 className={homeStyle.itemTitle}>{item.title}</h4>
                    <p className={homeStyle.description}>
                      {item.description && typeof item.description === "string"
                        ? parse(item.description)
                        : "No description available"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {/* Meet Our Directors */}
          {ourDirectorData?.length > 0 ? (
            <div className={homeStyle.directorsSection}>
              <h3 className={`${homeStyle.title} ${homeStyle.directorTitle}`}>Meet Our Directors</h3>
              <div className={homeStyle.directorsList}>
                {ourDirectorData.map((item, index) => (
                  <div key={index} className={homeStyle.directorRow}>
                    <img
                      src={config.baseURL + item?.image}
                      alt={item?.name || "Director Image"}
                      className={homeStyle.directorImage}
                    />
                    <div className={homeStyle.directorDetails}>
                      <h4 className={homeStyle.directorName}>{item.name}</h4>
                      <p className={homeStyle.directorDescription}>
                        {item.description &&
                        typeof item.description === "string"
                          ? parse(item.description)
                          : "No description available"}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {testimonialData?.length > 0 ? (
            <div className={homeStyle.testimonialSection}>
              <h3 className={homeStyle.testimonialTitle}>
                What Our Clients Say
              </h3>
              <div className={homeStyle.testimonialGrid}>
                {testimonialData.map((testimonial, index) => (
                  <div key={index} className={homeStyle.testimonialCard}>
                    <h4 className={homeStyle.testimonialName}>
                      {testimonial.name}
                    </h4>
                    <p className={homeStyle.testimonialDescription}>
                      {testimonial.description &&
                      typeof testimonial.description === "string"
                        ? parse(testimonial.description)
                        : "No description available"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : null
          }
        </div>
      )}
    </>
  );
};

export default Home;
